import React from 'react'
import './callCenterService.scss'

import { useHistory } from 'react-router-dom'

import CALL_SERVICE_DATA from './call_service_data.json'
import VO_SERVICE_ICON from '../../assets/VO_SERVICE_ICON.svg'

import Button from '../../components/button/Button'
import Footer from '../../components/footer/Footer'
import {useCountryContextContext} from "../../hooks/CountryContext";
import CountrySelection from "../../components/countrySelection/CountrySelection";
const CallCenterService = () => {
  const history = useHistory()
    const selectedCountry = useCountryContextContext();
    console.log({selectedCountry:selectedCountry.country.value})

  return (
    <>
      <div className="call_center">
        <div className="call_center__wrapper">
          <h2 className="primary__heading">Call Center Services</h2>
          <p>
            We specialize in top-quality customer care, inbound sales,
            order-processing, technical support, customer relationship
            management, chat support and email response. Top brands turn to
            Virtual Enterprise to deliver a superior customer service experience
            at various customer touch points.
          </p>
            <CountrySelection/>
          <div className="call_center__wrapper__items">
            {CALL_SERVICE_DATA.map(({ heading, description }) => (
              <ServiceItem heading={heading} description={description} />
            ))}
          </div>

          <Button
            onclick={() =>
              history.push({
                pathname: '/customize',
                state: { type: 'customize', subtype: 'customize' }
              })
            }
            type="primary"
            text="Start Now"
          />
        </div>
      </div>
      <Footer />
    </>
  )
}

const ServiceItem = ({ heading, description }) => {
  return (
    <div className="service_item">
      <div>
        <img src={VO_SERVICE_ICON} alt="" />
        <h2 className="secondary__heading">{heading}</h2>
      </div>
      <div>
        <p>{description}</p>
      </div>
    </div>
  )
}

export default CallCenterService
